/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { errorHandler, defs as CustomAPI } from './plugins/CustomAPI'
import IDMAPI from './plugins/IDMAPI'
import Auth from './plugins/Auth'
import moment from 'moment-timezone'
import axios from 'axios'
import Countries from './plugins/factory/Countries'
import Timezones from './plugins/factory/Timezones'
import VueFormWizard from 'vue-form-wizard'
import ThemifyIcon from "vue-themify-icons";
import Vuelidate from 'vuelidate';
import Popover from 'vue-js-popover'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import LoaderService from './plugins/factory/SharedService'
// import BaseExtension from './plugins/factory/BaseExtensions'

Vue.use(Vuelidate)
Vue.use(Popover)
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// fetch polyfill for IE11
import 'whatwg-fetch'

// cui.js requirements
import $ from 'jquery'
import lodash from 'lodash'

Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })
Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Object.defineProperty(Vue.prototype, '$axios', { value: axios })
Object.defineProperty(Vue.prototype, '$Loader', { value: LoaderService })
window.$ = $
window._ = lodash
require('@covisint/cui.js/dist/cui.min.js')
// require('vuelidate/dist/vuelidate.min.js')
// require('vuelidate/dist/validators.min.js')
//require('@covisint/cui-ng/dist/cui-ng.min.js')
Vue.use(VueFormWizard);
Vue.use(Vuelidate);

Vue.config.productionTip = false
/* eslint-disable */

Vue.filter('withoutProtocol', val => {
  // this filter will remove protocol from URL for display purposes
  if (!val) return ''
  return val.replace(/(^\w+:|^)\/\//, '')
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
})


Vue.filter('firstChar', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase()
})

Vue.filter('lastChar', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(value.length - 1).toUpperCase()
})

Vue.filter('changeDayFormat', function (value) {
  return moment(value).format('MMMM DD, YYYY');
})

Vue.filter('formatDate', function (utcDate, userTimezone) {
  var utcCutoff = moment.utc(utcDate);
  return moment.tz(utcCutoff.format('YYYYMMDD HH:mm:ss'), 'YYYYMMDD HH:mm:ss', userTimezone).format('MMMM DD, YYYY');
})

Vue.filter('formatDateTime', function (utcDate, userTimezone) {
  var utcCutoff = moment.utc(utcDate);
  return moment(moment.tz(utcCutoff.format('YYYYMMDD HH:mm:ss'), 'YYYYMMDD HH:mm:ss', userTimezone)._d).format('YYYY-MM-DD hh:mm A');
})

Vue.filter('formatMonthDate', function (utcDate, userTimezone) {
  return moment(utcDate).tz(userTimezone).format('MMMM DD, YYYY');
})

// library.add(faCoffee)

Vue.component('ThemifyIcon', ThemifyIcon)
async function appInit() {
  // uncomment to debug
  // window.cui.enableLog()
  /* eslint-disable no-new */
  await window.cui.api({
    sessionId: 1,
    serviceUrl: process.env.SERVICE_URL || 'STGBLUE',
    dataCallDefs: [
      CustomAPI,
      IDMAPI
    ]
  }).then((obj) => {
    Vue.prototype.$API = obj
    Vue.prototype.$redirectOps = window.location.hash.split('#')[1];
    Vue.prototype.$API.setAuthHandler(() => {
      return Vue.prototype.$API.covAuth({
        originUri: process.env.ORIGIN_URI,
        authRedirect: window.location.href.split('#')[0] + '#/auth',
        appRedirect: Vue.prototype.$redirectOps
      })
    })
    new Vue({
      el: '#app',
      router,
      store,
      vuetify,
      components: { App },
      template: '<App/>',
    })
    return Vue.prototype.$API.covAuthInfo({ originUri: process.env.ORIGIN_URI })
  }).fail((err) => {
    console.log(err)
  })
  Auth.authCheck(router.currentRoute).then(res => {
    /* eslint-disable no-new */
    if(localStorage.getItem('REFRESH') != 'false') {
      router.replace(localStorage.getItem('LS_ROUTE_KEY'))
    }else {
      router.replace('dashboard')
    }
  }, err => {
    errorHandler(err)
    console.log('ERROR: ', err)
  })
}
Countries.setCountries(store.getters.getCurrentLanguage)
Timezones.setTimezones(store.getters.getCurrentTimezone)
appInit()



// WEBPACK FOOTER //
// ./src/main.js